export function dateFormat(date: string | Date, includeDate: boolean = false, format?: string): string {
    if (!date) return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    if (format === 'en-US') {
        return `${month}/${day}/${year}${includeDate ? dateObj.toLocaleTimeString('en-US') : ''}`;
    } else if (format === 'es-ES') {
        return `${day}/${month}/${year}${includeDate ? dateObj.toLocaleTimeString('es-ES') : ''}`;
    }
    return `${day}/${month}/${year}${includeDate ? dateObj.toLocaleTimeString('pt-BR') : ''}`;
}

export function dateFormatTextual(date: string | Date, locale: string = 'pt-BR'): string {
    if (!date) return '';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    
    return dateObj.toLocaleDateString(locale, options);
}